const map = {
	"./BQ.webp": 1247,
	"./SL_logo 2.svg": 3705,
	"./SL_logo.png": 7039,
	"./SL_logo.svg": 9411,
	"./SL_logo.webp": 6601,
	"./Slajder_1.jpg": 2207,
	"./Slajder_2.jpg": 8592,
	"./Slajder_3.jpg": 9725,
	"./img/Melangerie/70057_Beaver.jpg": 2699,
	"./img/Melangerie/70058_Putty.jpg": 115,
	"./img/Melangerie/70059_Funghi.jpg": 181,
	"./img/Melangerie/70060_Wool.jpg": 5841,
	"./img/Melangerie/70061_Limestone.jpg": 1191,
	"./img/Melangerie/70062_Storm.jpg": 5733,
	"./img/Melangerie/70063_Pewter.jpg": 3230,
	"./img/Melangerie/70064_Petrol.jpg": 8336,
	"./img/Melangerie/70065_Ivy.jpg": 6383,
	"./img/Metis/70049_Latte.jpg": 7556,
	"./img/Metis/70050_Fogg.jpg": 981,
	"./img/Metis/70051_Stone.jpg": 1254,
	"./img/Metis/70052_Hazelnut.jpg": 1171,
	"./img/Metis/70053_Paloma.jpg": 4643,
	"./img/Metis/70054_Forest.jpg": 6465,
	"./img/Metis/70055_Midnight.jpg": 1265,
	"./img/Metis/70056_Smoke.jpg": 4105,
	"./img/Metis/70071_Snow.jpg": 8418,
	"./img/Metis/70072_Pingeon.jpg": 5754,
	"./img/Trench/70066_Murble.jpg": 1206,
	"./img/Trench/70067_Sesame.jpg": 1472,
	"./img/Trench/70068_Stell.jpg": 5821,
	"./img/Trench/70069_Nougat.jpg": 6830,
	"./img/Trench/70070_Dark.jpg": 3058,
	"./img/kontaktSzkic copy 3.webp": 8544,
	"./img/kontaktSzkic copy 4.webp": 3673,
	"./img/kontaktSzkic copy.webp": 2917,
	"./img/kontaktSzkic.webp": 6748,
	"./img/kontaktSzkiccopy2.webp": 5093,
	"./infoPdf.svg": 3080,
	"./menu_baroque.jpg": 7169,
	"./menu_fz.jpg": 1538,
	"./menu_ks.jpg": 6540,
	"./menu_lozko1.jpg": 1728,
	"./menu_lozko2.jpg": 5343,
	"./menu_lozko3.jpg": 7410,
	"./menu_pap.jpg": 1283,
	"./menu_rr.jpg": 3398,
	"./menu_sl.jpg": 5591,
	"./react-1.svg": 4065
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1131;